import { useState } from "react";
import logoJit from "/logoJit.png";
import { Link } from "@tanstack/react-router";
import { RouteUrl } from "@/configs/router/routes";
import { UserFeedbackDialog } from "./UserFeedbackDialog";

const Footer = () => {
    const [feedbackOpen, setFeedbackOpen] = useState(false);

    return (
        <>
            <footer className="bg-surface-container border-t border-outline-variant/20 py-4 px-6 lg:px-12">
                <div className="flex flex-col md:flex-row justify-between items-center gap-6">
                    <div className="flex flex-col items-center md:items-start gap-3">
                        <div className="flex items-center gap-3 opacity-70 hover:opacity-100 transition-opacity">
                            <a href="https://jit.team/" target="_blank" rel="noopener noreferrer">
                                <img src={logoJit} alt="Jit Team" className="h-7" style={{ filter: "invert(1)" }} />
                            </a>
                        </div>
                    </div>
                    <nav id="onboarding-footer-nav" className="flex flex-wrap justify-center gap-8 md:gap-10">
                        <button
                            onClick={() => setFeedbackOpen(true)}
                            className="text-[11px] font-headline font-bold text-on-surface-variant hover:text-primary uppercase tracking-widest transition-colors hover:cursor-pointer"
                        >
                            Feedback
                        </button>
                        <Link
                            to={RouteUrl.PrivacyPolicy}
                            className="text-[11px] font-headline font-bold text-on-surface-variant hover:text-primary uppercase tracking-widest transition-colors"
                        >
                            Privacy Policy
                        </Link>
                        <Link
                            to={RouteUrl.SystemStatus}
                            className="flex items-center gap-2 text-[11px] font-headline font-bold text-on-surface-variant hover:text-primary uppercase tracking-widest transition-colors"
                        >
                            <span className="w-2 h-2 rounded-full bg-green-500 inline-block" />
                            System Status
                        </Link>
                    </nav>
                </div>
            </footer>
            <UserFeedbackDialog isOpen={feedbackOpen} onClose={() => setFeedbackOpen(false)} />
        </>
    );
};

export default Footer;
